import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { baseURL, apiBaseUrlOverride } from '@constants/URL'

const isHomolog = process.env.VUE_APP_HOMOLOG === 'true'
const productionMode = process.env.NODE_ENV === 'production'
const isTestEnv = process.env.VUE_APP_TEST_ENV === 'true'
const defaultUrl = productionMode && !isHomolog ? 'prod' : 'dev'
const url = isTestEnv ? 'local' : defaultUrl

// `VUE_APP_API_BASE_URL` vence sobre a escolha por NODE_ENV. Sem a variável,
// `apiBaseUrlOverride` é '' e as duas expressões abaixo caem no valor de sempre.
const resolvedBaseURL = apiBaseUrlOverride || baseURL[url]
const axiosBaseURL =
  apiBaseUrlOverride || (productionMode && !isHomolog ? '' : baseURL[url])

if (process.env.NODE_ENV !== 'test') {
  console.log('axios:baseURL:', resolvedBaseURL)
}

global.BASE_URL = resolvedBaseURL

const api = axios.create({
  baseURL: axiosBaseURL,
  withCredentials: true,
  headers: {
    ...(productionMode && {
      'Content-Type': 'multipart/form-data',
      'Access-Control-Allow-Origin': '*',
    }),
  },
  crossDomain: true,
})

if (process.env.NODE_ENV !== 'test') {
  console.log(productionMode, '## Utilizando base: ', resolvedBaseURL)
}

if (productionMode) {
  api.defaults.headers.post['Content-Type'] = 'multipart/form-data' // 'application/x-www-form-urlencoded'
  api.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
}

const getErrorMessage = (error) => {
  if (!error) {
    return 'Erro na preparação da requisição'
  }
  if (typeof error === 'string') {
    return error
  }
  if (typeof error === 'object') {
    if (typeof error.message === 'string' && error.message.trim()) {
      return error.message
    }
    try {
      return JSON.stringify(error)
    } catch {
      return 'Erro na preparação da requisição'
    }
  }
  return String(error)
}

api.interceptors.request.use(
  (config) => config,
  (error) => {
    if (error instanceof Error) {
      return Promise.reject(error)
    }
    const wrappedError = new Error(getErrorMessage(error))
    if (error && typeof error === 'object') {
      wrappedError.cause = error
    }
    wrappedError.originalError = error
    return Promise.reject(wrappedError)
  }
)

Vue.use(VueAxios, axios)

export default api
